import { z } from 'zod'

import { viewUiComponentTypeSchema } from './enum.ts'
import { kpiAppearanceSchema, kpiSchema } from './kpi.ts'

export const kpiPivotSchema = kpiSchema.omit({ kpi: true }).extend({
  type: z.literal(viewUiComponentTypeSchema.enum.KpiPivotSheet),
  kpis: kpiAppearanceSchema.array(),
})
export type ViewUiKpiPivot = z.infer<typeof kpiPivotSchema>
